module.exports = __webpack_public_path__ + "img/arcarta.602f1142.svg";